import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { DashboardDataServiceService } from 'src/app/services/dashboard-data-service.service';
import Swal from 'sweetalert2';
import { CollectionPopupComponent } from '../collection-popup/collection-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification-service';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ExcelService } from 'src/app/services/excel.service';
import moment from 'moment';
import { AddDevicePopupComponent } from '../add-device-popup/add-device-popup.component';
import { MatPaginator } from '@angular/material/paginator';


@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {
  selectedIndex: any;
  form: FormGroup
  data = []
  dataSource = new MatTableDataSource(this.data)


  dataExcel
  displayedColumns = [
    "FNO",
    "Application",
    "Code",
    "Name",
    "Contact",
    "Address",
    "CollectionDate",
    "CollectionNotes",
    "Agent",
    "Action"
  ]
  showcollection = false;
  isGetAllCollectionRecord = false
  isCollectionRecordOnly = false
  excelColumns: string[];
  constructor(
    private formBuilder: FormBuilder,
    private dashboarddataserviceService: DashboardDataServiceService,
    private applicationdataservice: ApplicationDataService,
    private matdialog: MatDialog,
    private toastr: NotificationService,
    private datePipe: DatePipe,
    private loaderService: LoaderService,
    private excelService: ExcelService,

  ) { }
  @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator>;


  @ViewChild('searchInput') searchInput: ElementRef

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: [null,],
    })
    this.getcollection(true)
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index
    this.clearFilter();
  }

  getcollectiondata(data) {
    this.dashboarddataserviceService.getCancellationApplicationsSearch(data).subscribe((result) => {
      this.data = result
      this.dataSource = new MatTableDataSource(this.data)
      this.paginators.toArray()[0].pageIndex = 0; // Reset first paginator
      this.dataSource.paginator = this.paginators.toArray()[0];
      if (data.searchQuery)
        this.dataExcel = this.data
      this.showcollection = true

    })
  }
  getlegalcollectiondata(data) {
    this.dashboarddataserviceService.getLegalCollections(data).subscribe((result) => {
      this.data = result
      this.dataSource = new MatTableDataSource(this.data)
      this.paginators.toArray()[1].pageIndex = 0; // Reset first paginator
      this.dataSource.paginator = this.paginators.toArray()[1];
      // this.dataSource.paginator.page.subscribe(() => {
      //   this.dataSource._updateChangeSubscription();  // Force the update on page change
      // });
      this.dataExcel = this.data
      this.showcollection = true

    })
  }
  getcollection(flag) {
    let value = {
      isCollectionRecordOnly: true,
      isGetAllCollectionRecord: false
    }
    this.form.reset()
    this.isCollectionRecordOnly = true;
    if (flag)
      this.getcollectiondata(value)
    else
      this.getlegalcollectiondata(value)
  }

  search(flag) {
    if (this.form.value.searchQuery) {
      let value = {
        searchQuery: this.form.value.searchQuery,
        isCollectionRecordOnly: false,
        isGetAllCollectionRecord: false,
      }
      this.isCollectionRecordOnly = false
      if (flag)
        this.getcollectiondata(value)
      else
        this.getlegalcollectiondata(value)

    }

  }

  view(data, falg, header = null) {
    let value = {
      searchQuery: this.form.value.searchQuery,
      isCollectionRecordOnly: true,
      isGetAllCollectionRecord: false
    }
    if (this.form.value.searchQuery)
      value.isCollectionRecordOnly = false
    if (falg) {
      const dialogref = this.matdialog.open(CollectionPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          title: header
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        if (result) {
          let postData = {
            UserRefrenceNumber: data,
            collectionDate: this.formatDate(result.collectionDate),
            comments: result.comments
          }

          if (header == 'Collection')
            this.applicationdataservice.saveCollection(postData).subscribe((result) => {
              if (result) {
                this.toastr.showSuccess('Collection Added Successfully')
                this.getcollectiondata(value)

              }
            })
          else {
            this.applicationdataservice.saveLegalCollection(postData).subscribe((result) => {
              if (result) {
                this.toastr.showSuccess('Legal Collection Added Successfully')
                this.getlegalcollectiondata(value)

              }
            })
          }
        }
      })

    }
    else {
      const txt = 'Do you want to revoke this collections ?';
      const Yes = 'Yes';
      const No = 'No';
      Swal.fire({
        text: txt,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }).then((result) => {
        if (result.value) {
          var postData = {
            userRefrenceNumber: data
          }
          this.applicationdataservice.saveRevokeCollection(postData).subscribe((result) => {
            if (result) {
              this.toastr.showSuccess('Success!', 'Collections revoked successfully!')
              if (header == 'Collection')
                this.getcollectiondata(value)
              else
                this.getlegalcollectiondata(value)
            }
          })
        }
      })
    }

  }
  clearFilter() {

    // this.showcollection = false;
    this.searchInput.nativeElement.value = ''
    this.data = null
    this.dataExcel = null
    this.form.reset()
    if (this.selectedIndex == 0 || this.selectedIndex == undefined)
      this.getcollection(true)
    else
      this.getcollection(false)
  }
  exportAsXLSX(head): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        // "S.No",
        "FNO",
        "Application",
        "Customer Code",
        "Customer",
        // "Contact",
        // "Address",
        "CollectionDate",
        "CollectionNotes",
        // "Agent",

      ];
      exportData.forEach((a, index) => {
        let customerName = a.customerName;
        let maskedName = this.encryptionname(customerName);
        excelList.push({
          // sno: ++index,
          "FNO": a.serviceProviderName,
          "Application": a.applicationReferenceNumber,
          "Customer Code": a.userRefrenceNumber,
          "Customer": maskedName,
          // "Contact": a.mobileNumber,
          // "Address": a.address,
          "CollectionDate": head === "Collection_" ? a.collectionDate : a.legalCollectionDate,
          "CollectionNotes": head === "Collection_" ? a.collectionComments : a.legalCollectionComments,
          // "Agent": head === "Collection_" ? a.collectionAgentName : a.legalCollectionAgentName,
        });
      });


      this.excelService.exportAsExcelFile(excelList, head + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
  async collectionexportAsXLSX(head) {
    let value: any = {
      isCollectionRecordOnly: true,
      isGetAllCollectionRecord: false
    }
    let dataExcel1;
    if (head === 'Collection_') {
      dataExcel1 = await new Promise((resolve, reject) => {
        this.dashboarddataserviceService.getCancellationApplicationsSearch(value).subscribe(
          (result) => resolve(result),
          (error) => reject(error)
        );
      });
    } else {
      dataExcel1 = await new Promise((resolve, reject) => {
        this.dashboarddataserviceService.getLegalCollections(value).subscribe(
          (result) => resolve(result),
          (error) => reject(error)
        );
      });
    }
    this.loaderService.start();

    if (!dataExcel1 || dataExcel1.length === 0) {
      this.toastr.showInfo("No data available to export");
      this.loaderService.hide();
      return;
    }

    const excelList = [];
    this.excelColumns = [
      // "S.No",
      "FNO",
      "Application",
      "Customer Code",
      "Customer",
      // "Contact",
      // "Address",
      "CollectionDate",
      "CollectionNotes",
      // "Agent",
    ];

    dataExcel1.forEach((a, index) => {
      let customerName = a.customerName;
      let maskedName = this.encryptionname(customerName);
      excelList.push({
        // sno: ++index,
        "FNO": a.serviceProviderName,
        "Application": a.applicationReferenceNumber,
        "Customer Code": a.userRefrenceNumber,
        "Name": maskedName,
        // "Contact": a.mobileNumber,
        // "Address": a.address,
        "CollectionDate": head === "Collection_" ? a.collectionDate : a.legalCollectionDate,
        "CollectionNotes": head === "Collection_" ? a.collectionComments : a.legalCollectionComments,
        // "Agent": head === "Collection_" ? a.collectionAgentName : a.legalCollectionAgentName,
      });
    });

    this.excelService.exportAsExcelFile(excelList, head + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
    this.loaderService.stop();
  }

  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }
  formatDate(controlName: string) {
    const formattedDate = this.datePipe.transform(controlName, 'MM/dd/yyyy');
    return formattedDate;
  }

  importexcel(contetn, head) {


    const dialogref = this.matdialog.open(AddDevicePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "40%",
      data: {
        title: contetn,
        head: head
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result && contetn == 'legalexcelimport') {
        this.dashboarddataserviceService.UploadLegalCollectionData(result).subscribe((result) => {
          if (result)
            //   Swal.fire('Error!', result, 'error')
            // else {
            Swal.fire('Success','Uploaded successfully and the process will be started shortly','success')
          // this.getTableData()
          // }

        })
      }
      else if (result) {
        this.dashboarddataserviceService.UploadRevokeLegalCollectionData(result).subscribe((result) => {
          if (result)
            //   Swal.fire('Error!', result, 'error')
            // else {
            Swal.fire('Success','Uploaded successfully and the process will be started shortly','success')

          // this.getTableData()
          // }

        })
      }
    })
  }

}


